import { createTheme, ThemeOptions } from "@mui/material/styles";
import { componentOverrides } from "./componentOverrides";

export const createBaseTheme = (options: ThemeOptions) => {
  return createTheme({
    ...options,
    components: {
      ...componentOverrides,
      ...options.components, // allow consumer overrides
    },
  });
};
